import $ from 'jquery';
import Swiper , { Autoplay } from 'swiper';

function initLogosSlider() {
    $(function () {
        if ($('.logos-slider').length <= 0) {
            return;
        }

        //customizeSliderStyles();
        initSwiperLogosJS();
    });
}

function initSwiperLogosJS(elements) {
    Swiper.use([Autoplay]);
    $('.logos-slider').each(function(){
        let slider1 = $(this).find('.slider-1');
        let slider2 = $(this).find('.slider-2');

        // Initialize the first slider
        if(slider1.length){
            var slide1Clone = slider1.find('.slide').clone();
            //slider1.find('.swiper-wrapper').append(slide1Clone).append(slide1Clone);
            new Swiper(slider1.get(0), {
                spaceBetween: 0,
                centeredSlides: false,
                autoplay: {
                    delay: 1,
                },
                speed: 6000,
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: false,
                disableOnInteraction: true,
                spaceBetween: 32,
                breakpoints: {
                    768: {
                        spaceBetween: 70,
                    },
                },
            });
        }

        // Initialize the second slider with reversed direction
        if(slider2.length){
            var slide2Clone = slider2.find('.slide').clone();
            //slider2.find('.swiper-wrapper').append(slide2Clone).append(slide2Clone);
            new Swiper(slider2.get(0), {
                spaceBetween: 32,
                centeredSlides: false,
                autoplay: {
                    delay: 1,
                    reverseDirection: true
                },
                speed: 6000,
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });
        }
    });
    
}

export { initLogosSlider };
